import { Component, EventEmitter, Input, Output } from '@angular/core';
import { hasInvitationsReselector } from 'src/app/store/reselectors/accounts.reselector';
import { DashboardPageType, HomeType } from 'globals/store/user.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { CommonModule } from '@angular/common';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { InvitationsComponent } from '../home/invitations.component';

@Component({
    selector: 'home-wrapper',
    template: `
<joi-nav-wrapper
  class="home-nav"
  *ngIf="homeTab"
  [menuItems]="homeTabs"
  [hiddenMobileItems]="hiddenMobileItems"
  [selectedId]="homeTab" 
  (selectItem)="changeHomeTab($event)"
>
  <ng-container *ngIf="homeTab === 'EVENTS'">
    <div class="icons-label desktop">View:</div>
    <joi-nav-wrapper
      class="icon-tabs"
      [menuItems]="eventMenuItems"
      [menuMap]="eventMenuMap"
      [onlyIcons]="true"
      [iconMap]="eventIconMap"
      [selectedId]="eventViewType || 'card'" 
      (selectItem)="saveEventViewType($event)"
    ></joi-nav-wrapper>
  </ng-container>
  <ng-container *ngIf="homeTab === 'TASKS'">
    <div class="icons-label">View:</div>
    <joi-nav-wrapper
      class="icon-tabs"
      [menuItems]="taskMenuItems"
      [menuMap]="eventMenuMap"
      [onlyIcons]="true"
      [iconMap]="eventIconMap"
      [selectedId]="viewMode" 
      (selectItem)="changeViewMode.emit($event)"
    ></joi-nav-wrapper>
  </ng-container>
</joi-nav-wrapper>
<div class="scrolling-wrapper">
  <invitations *ngIf="hasInvitations"></invitations>
  <div [class]="'content-wrapper '+ viewMode">
    <ng-content></ng-content>
  </div>
</div>
`,
    styleUrls: ['./home-wrapper.scss'],
    imports: [CommonModule, JoiNavWrapper, InvitationsComponent ],
    standalone: true
})
export class HomeWrapperComponent extends Wrapper<HomeWrapperComponent> {
  @Input() homeTab: HomeType = 'EVENTS'
  homeTabs: HomeType[] = ['EVENTS', 'TASKS', 'PUBLISH', 'CLIPBOARD', 'BUDGET']
  hiddenMobileItems: Set<HomeType> = new Set(['BUDGET'])
  eventViewType: DashboardPageType = 'card'
  eventMenuMap: { [k in DashboardPageType]: string } = { card: 'CARD', table: 'TABLE', list: 'LIST', calendar: 'CALENDAR' }
  eventMenuItems: DashboardPageType[] = ['card', 'list', 'calendar' ]
  taskMenuItems: DashboardPageType[] = ['table', 'calendar' ]
  eventIconMap: { [k in DashboardPageType]: string } = { card: 'card', table: 'list', list: 'list', calendar: 'calendar' }
  hide = true
  @Input() forceShow = false
  @Input() viewMode: DashboardPageType = 'list'
  @Output() changeViewMode: EventEmitter<DashboardPageType> = new EventEmitter()
  homeNavPathRegex: RegExp = new RegExp(/^\/home|^\/publish/)
  hasInvitations = false

  constructor() {
    super()
    this.subProp(this.store.select('settings','user','homepage'), 'eventViewType')
    this.subProp(this.store.select(hasInvitationsReselector), 'hasInvitations')
    this.subCallback(this.store.select('router', 'state', 'url'), url => {
      if (!url) {
        this.hide = true
        return
      }
      this.hide = !url.match(this.homeNavPathRegex)
    })
  }

  changeHomeTab(homeTab: HomeType) {
    // console.log({ homeTab })
    if (homeTab === this.homeTab) return
    switch (homeTab) {
      case 'EVENTS':
        this.navigateHome(this.eventViewType)
        break
      case 'PUBLISH':
        this.router.navigate(['event-lists'])
        break
      case 'TASKS':
        this.router.navigate(['tasks'])
        break
      case 'CLIPBOARD':
        this.router.navigate(['clipboard'])
        break
      case 'BUDGET':
        this.router.navigate(['budget'])
        break
      default:
        console.log(`MISSING HANDLING FOR CHANGE HOME TAB: [${homeTab}]`)
        break
    }
    // this.homeTab = homeTab
  }

  navigateHome(pageType: DashboardPageType) {
    this.router.navigate(['home', pageType === 'card' ? '' : pageType])
  }

  saveEventViewType(pageType: DashboardPageType) {
    // console.log({ pageType })
    this.settingsService.saveUserSetting('homepage', pageType)
    setTimeout(()=> this.navigateHome(pageType), 0)
  }

}

